import React, { useContext } from "react";
import { LegacyCard as Card, InlineStack, Link, Text, DataTable } from "@shopify/polaris";

import { PrivateContext } from "lib/context";
import constant from "lib/constant/constant";
import { customerProp } from "app/orders/modules/operator/features/view/propsType";

const VendorFulfillments = (props) => {
  const { lineData } = props;
  const { cms } = useContext(PrivateContext);

  const getFulfillmentStack = (item) => {
    return [
      <>
        <Link url="">{item.name}</Link>
        <Text variant="bodySm" as="p">
          <Text as="span" tone="subdued">
            {`${cms("label.vendor")}: `}
            <Link>{item.vendor}</Link>
          </Text>
        </Text>
      </>,
      <Text as="span">{item.vendorTrackingCompany}</Text>,
      <Text as="span">{item.vendorTrackingNumber}</Text>,
    ];
  };

  const fulfillments = lineData
    .filter(
      (item) => item.isVendorFulfilled && !item.isConsignmentPick && item.fulfillmentStatus !== constant.FULFILLED
    )
    .map((selectedItem) => getFulfillmentStack(selectedItem));

  return (
    <div className="add-ellipsis">
      <Card.Section subdued>
        <DataTable
          columnContentTypes={["text", "numeric", "numeric"]}
          headings={[cms("label.product"), cms("label.shippingCompany"), cms("label.trackingNumber")]}
          rows={fulfillments}
        />
      </Card.Section>
      <Card>
        <Card.Section>
          <InlineStack blockAlign="center">
            <Text as="span" fontWeight="semibold">
              {cms("label.totalFulfillments")}
            </Text>
            <Text as="span" fontWeight="bold">
              {`${fulfillments.length} ${cms("label.of")} ${lineData.length}`}
            </Text>
          </InlineStack>
        </Card.Section>
      </Card>
    </div>
  );
};

VendorFulfillments.propTypes = customerProp.type;
export default VendorFulfillments;
